export const COLORS = {
    PRIMARY: '#E776B6',
    MID_LIGHT: '#E5A0D4',
    LIGHT: '#F4C0DD',
    FULL_LIGHT: '#F8E9F5',
    FULL_LIGHT_2: '#FCF7FB',
    MID_DARK: '#8F4A7E',
    DARK: '#4D273C',
    NAVBAR: 'white',
    RED_BTN: '#C40202',
    SUCCESS_BTN: ''
}